<template>
  <section class="brand-marketing brief">
    <div class="marketing-box">
      <h5 class="marketing-title">{{ title }}</h5>
      <p class="marketing-desc">{{ remarks }}</p>
      <button class="login-btn" @click="$toUse()">
        <span>马上开始</span>
        <span class="flex-align-center iconpark-icon-box">
          <svg class="iconpark-icon">
            <use href="#arrow-right"></use>
          </svg>
        </span>
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: "startNow",
  props: {
    title: {
      type: String,
      default: "",
    },
    remarks: {
      type: String,
      default: "",
    },
  },
};
</script>

<style>
</style>